import { Outlet } from 'react-router-dom';
import { JumboList, LinkItem } from '../components/JumboList';

const entries = [
  new LinkItem('/portfolio/web-development', 'Web Development'),
  new LinkItem('/portfolio/renamerfx', 'RenamerFX'),
  new LinkItem('/portfolio/desktop-design', 'Desktop Design'),
  new LinkItem('/portfolio/linux-experience', 'Linux Experience'),
];

export function PortfolioList() {
  return (
    <JumboList items={entries} height='h-48' />
  );
}

export function Portfolio() {
  return (
    <div>
      <Outlet />
    </div>
  );
}